module.exports = __webpack_public_path__ + "img/arrow-3.9811b099.svg";